// extracted by mini-css-extract-plugin
module.exports = {"img":"ProjectPageTemplate-module--img--5AkPh","moreInfoTitle":"ProjectPageTemplate-module--more-info-title--1kXxi","moreInfo":"ProjectPageTemplate-module--more-info--2aDQC"};